export default "__VITE_ASSET__Bl3GdNqP__"